const Job = () => import("@/views/administrator/job/Job.vue");
const TeiLog = () => import("@/views/administrator/teiLog/TeiLog.vue");
const SoapLog = () => import("@/views/administrator/soapLog/SoapLog.vue");
const SicState = () => import("@/views/administrator/sicState/SicState.vue");

const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/administrator/EmptyRouterView.vue");
const Administrator = () => /* webpackChunkName: "HomeAdministrator" */ import("./../views/administrator/Home.vue");
const User = () => /* webpackChunkName: "Users" */ import("./../views/administrator/users/Users.vue");
const ManteinerArticle = () => /* webpackChunkName: "HomeArticleNode" */ import("./../views/administrator/articles_node/Home.vue");
const ManteinerSpecialtiesSigte = () => /* webpackChunkName: "SpecialtiesSigte" */ import("./../views/administrator/specialtiesSigte/SpecialtiesSigte.vue");
const MainteinerFavourites = () => /* webpackChunkName: "Favorites" */ import("./../views/administrator/favourites/Favourites.vue");
const Dashboard = () => /* webpackChunkName: "Dashboard" */ import("./../views/administrator/dashboard/Dashboard.vue");
const RayenIntegrationHistory = () =>
  /* webpackChunkName: "RayenIntegrationHistory" */ import("./../views/administrator/integrations/RayenIntegrationHistory.vue");
const ManteinerSpecialtiesHis = () => /* webpackChunkName: "SpecialtiesHis" */ import("./../views/administrator/SpecialtiesHis/SpecialtiesHis.vue");
const ManteinerStablishment = () => /* webpackChunkName: "Stablishment" */ import("./../views/administrator/Stablishment/Stablishment.vue");
const ErrorLog = () => /* webpackChunkName: "ErrorLog" */ import("@/views/administrator/errorLog/ErrorLog.vue");
const FileRepository = () => /* webpackChunkName: "HomeFileRepository" */ import("@/views/administrator/fileRepository/Home.vue");
const Document = () => /* webpackChunkName: "DocumentGeneral" */ import("@/views/general/Document.vue");
const BenefitMaintainer = () => /* webpackChunkName: "BenefitMaintainer" */ import("@/views/administrator/benefit/BenefitMaintainer.vue");
const MaintainerBlockedDay = () => /* webpackChunkName: "MaintainerBlockedDay" */ import("@/views/some_hcm/MaintainerBlockedDay.vue");

export const routes = [
  {
    path: "/administrador",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "administratorHome",
        component: Administrator,
      },
      {
        path: "usuarios",
        name: "administratorUser",
        component: User,
      },
      {
        path: "mantenedor-articulos",
        name: "administratorManteinerArticleHome",
        component: ManteinerArticle,
      },
      {
        path: "mantenedor-especialidades-sigte",
        name: "administratorSpecialtySigte",
        component: ManteinerSpecialtiesSigte,
      },
      {
        path: "mantenedor-especialidades-his",
        name: "administratorSpecialtyHis",
        component: ManteinerSpecialtiesHis,
      },
      {
        path: "mantenedor-favoritos",
        name: "administratorFavorites",
        component: MainteinerFavourites,
      },
      {
        path: "dashboard",
        name: "administratorDashboard",
        component: Dashboard,
      },
      {
        path: "historial-integracion-pacientes-rayen",
        name: "administratorIntegrationRayenHistories",
        component: RayenIntegrationHistory,
      },
      {
        path: "mantenedor-establecimiento",
        name: "administratorManteinerStablishment",
        component: ManteinerStablishment,
      },
      {
        path: "mantenedor-prestaciones",
        name: "administratorMaintainerBenefit",
        component: BenefitMaintainer,
      },
      {
        path: "errorLog",
        name: "administratorErrorLog",
        component: ErrorLog,
      },
      {
        path: "mantenedor-manuales",
        name: "administratorFileRepository",
        component: FileRepository,
      },
      {
        path: "documentacion",
        name: "administratorDocumentation",
        component: Document,
      },
      {
        path: "mantenerdor-dias-bloqueados",
        name: "manteinerBlockedDayAdministrator",
        component: MaintainerBlockedDay,
      },
      {
        path: "jobAdministrator",
        name: "jobAdministrator",
        component: Job,
      },
      {
        path: "teiLogAdministrator",
        name: "teiLogAdministrator",
        component: TeiLog,
      },
      {
        path: "soapLogAdministrator",
        name: "soapLogAdministrator",
        component: SoapLog,
      },
      {
        path: "cargar-estado-sic",
        name: "sicStateAdministrator",
        component: SicState,
      },
    ],
  },
];
